import styled from 'styled-components';
import * as tokens from '../../tokens';

export const TotalWrapper = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  flex-direction: row;
  margin-top: 50px;
`;
